module.exports = __webpack_public_path__ + "static/img/chejia_dd_qcode.caf9af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_dd_qcode.png
// module id = 9Eg6
// module chunks = 19